import React from 'react'
import { IconButton, Icon } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'

const useApproveStyles = makeStyles((theme) => ({
  root: {
    color: 'rgba(0, 0, 0, 0.54)',
    '&:hover': {
      color: '#4fd975',
    },
  },
}))

export default (props) => {
  const classes = useApproveStyles()
  return (
    <IconButton {...props}>
      <Icon className={classes.root}>check_circle</Icon>
    </IconButton>
  )
}
